import React from 'react';
import {Modal} from 'react-bootstrap';
import PropTypes from 'prop-types';
import Button from '../../../common/button';

const EmailPreview = ({onClose, show, children}) => (
  <div className="modal-container">

    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>
          Email Preview
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{__html: children}} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </div>
);

EmailPreview.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

EmailPreview.defaultProps = {
  show: false,
};

export default EmailPreview;



// WEBPACK FOOTER //
// ./src/components/admin/notifications/email/email-preview.jsx